import { useQuery } from '@tanstack/react-query';
import {
  type CarrierSettingsEntry,
  type ConnectedCarrierAccounts,
  connectedCarrierAccounts,
} from '@utility/own-carrier-account';
import ShippingLabelsCarriersService from '@utility/services/shipping-labels-carriers';

const EMPTY: ConnectedCarrierAccounts = {};

/**
 * The carrier accounts the workspace connected itself, to mark the rates they
 * quote. A failed lookup marks nothing rather than guessing.
 */
export function useConnectedCarrierAccounts(
  organizationId?: string,
): ConnectedCarrierAccounts {
  const { data } = useQuery({
    queryKey: ['shipping-labels', 'carriers', 'connected', organizationId],
    queryFn: async () => {
      const result: { data?: CarrierSettingsEntry[] } =
        await ShippingLabelsCarriersService.get();

      return connectedCarrierAccounts(result?.data);
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!organizationId,
  });

  return data || EMPTY;
}
